import React, { useState, useEffect } from "react";
import sanityClient from "../client"; // Ensure this points to your Sanity client
import "./styles/faq.scss";

const Faq = () => {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "faq"]{
          _id,
          question,
          answer
        }`
      )
      .then((data) => setFaqs(data))
      .catch(console.error);
  }, []);

  return (
    <div className="faq-container">
      <h2>Frequently Asked Questions</h2>
      {faqs.map((faq) => (
        <details key={faq._id}>
          <summary>
            {faq.question}
            <svg className="control-icon control-icon-expand" width="24" height="24" role="presentation">
              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#expand-more" />
            </svg>
            <svg className="control-icon control-icon-close" width="24" height="24" role="presentation">
              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#close" />
            </svg>
          </summary>
          <p>{faq.answer}</p>
        </details>
      ))}
    </div>
  );
};

export default Faq;
